import styled from 'styled-components';
export const Container = styled.div`
   display: flex;
   padding: 0.5rem 0.5rem 0 0.5rem;
   flex-direction: column;
   gap: 0.3rem;
   border-radius: 10px;
   opacity: 0.8;
   background-color: #cfc6bf;
   user-select: none;
   border-left: 8px solid #ff0000;
   .children__{
   }
   .action__{
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 0.3rem;
      .icon--{
         cursor: pointer;
         font-size: 1.3rem;
         > svg {
            margin-top: 5px;
         }
      }
   }
   .error_msg {
      display: flex;
      justify-content: center;
      margin-bottom: 0.5rem;
   }
   
`